import { Card } from "react-bootstrap";
import React, { useCallback, useRef, useState } from "react";
import CustomStore from "devextreme/data/custom_store";
import { getAllDiamondProductInventoryData } from "../services/diamond-product-inventory.service";
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Selection, Summary, TotalItem, } from "devextreme-react/cjs/data-grid";
import { HttpStatus, UpdateInwardDataIds } from "modules/core";
import notistack from "modules/core/notistack";
import { updateGoldAndDiamondInventoryRecords } from "utils/inward";
import { UpdateInventoryReturnDataIds } from "../model";
import { useNavigate } from "react-router-dom";
import { HasPermission } from "Layout/Permissions/permissionsCache";


const DiamondProductInventory = () => {
    let setSelectedRows: Array<number> = [];
    const dataGridRef = useRef<DataGrid>(null);
    const navigate = useNavigate()


    const dataSource = new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
            try {
                const { searchValue, skip, take } = loadOptions;
                const parameterList = new URLSearchParams();
                if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                if (typeof take === 'number') parameterList.append('take', take.toString());
                const search = JSON.parse(JSON.stringify(loadOptions));
                for (const [key, value] of Object.entries(search)) {
                    parameterList.append(key, JSON.stringify(value));
                }
                if (searchValue) {
                    parameterList.append("search", searchValue);
                }
                parameterList.append("MaterialType", 'diamond');
                parameterList.append("IsSNMCC", 'false');
                parameterList.append("IsReceived", 'true');
                const response = await getAllDiamondProductInventoryData(parameterList);
                return response
            } catch (error) {
                console.error("Data loading error:", error);
                return { data: [], totalCount: 0 };
            }
        }
    });

    const renderSerialNumber = useCallback((cellData: any) => {
        const rowIndex = cellData.rowIndex + 1 + cellData.component.pageIndex() * cellData.component.pageSize();
        return <span>{rowIndex}</span>;
    }, []);

    const handleSelectionChange = (e: any) => {
        setSelectedRows = e.selectedRowsData.map((item: any) => item.id);
    };

    const updateDiamondAndGoldInventory = async () => {
        try {
            if (setSelectedRows.length > 0) {
                const model = new UpdateInventoryReturnDataIds();
                model.returnToMayaveProductIdList = setSelectedRows;
                const response = await updateGoldAndDiamondInventoryRecords(model);

                if (response.status === 200) {
                    dataGridRef.current?.instance.clearSelection();
                    dataGridRef.current?.instance.refresh();
                    notistack.notifyFromApi(response);
                } else {
                    notistack.notifyFromApi(response);
                }
            } else {
                notistack.warning("Please Select Product");
            }
        } catch (error) {
            console.error("Failed to update inventory:", error);
            notistack.error("An unexpected error occurred. Please try again.");
        }
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Diamond Product Inventory </h5>

                            {HasPermission('ProductHeader.Write') && <button onClick={updateDiamondAndGoldInventory} className="submit-btn">
                                Return
                            </button>}
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {HasPermission('ProductHeader.Read') &&
                                <DataGrid
                                    dataSource={dataSource}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    ref={dataGridRef}
                                    columnAutoWidth={true}
                                    showBorders={true}
                                    onSelectionChanged={handleSelectionChange}

                                    // for hide
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}

                                    // for text-center 
                                    onCellPrepared={(e) => {
                                        if (['data', 'header'].includes(e.rowType)) {
                                            e.cellElement.style.textAlign = 'center';
                                        }
                                    }}

                                >
                                    <Selection
                                        mode="multiple"
                                    />
                                    <Scrolling
                                        mode='standard'
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />

                                    <Pager

                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <Summary>
                                        <TotalItem
                                        // column="Sr.No."
                                        // summaryType="count"
                                        // displayFormat="Total: {0}"
                                        />
                                    </Summary>
                                    <Paging defaultPageSize={10} />
                                    <SearchPanel visible width={240} placeholder="Search..." />
                                    <Column
                                        caption="Sr.No."
                                        dataType="number"
                                        alignment="center"
                                        cellRender={renderSerialNumber}
                                    />
                                    <Column allowFiltering={true} dataField="storeCode" caption="Store Code" dataType="string" />
                                    <Column allowFiltering={true} dataField="tag" caption="Tag" dataType="string" />
                                    <Column allowFiltering={true} dataField="invoiceNo" caption="Invoice Number" dataType="string" />
                                    <Column allowFiltering={false} dataField="invoiceDate" caption="Invoice Date" dataType="date" format="dd/MM/yyyy" />
                                    <Column allowFiltering={true} dataField="styleNo" caption="Style Number" dataType="string" />
                                    <Column allowFiltering={true} dataField="bagNo" caption="BagNo." dataType="string" />
                                    <Column allowFiltering={false} dataField="netWt" format="#,##0.000" caption="Net Weight" dataType="string" />
                                    <Column allowFiltering={false} dataField="metalKT" caption="Metal KT" dataType="string" />
                                    <Column allowFiltering={false} dataField="categoryName" caption="Category Name" dataType="string" />
                                    <Column allowFiltering={false} dataField="grossWt" format="#,##0.000" caption="Gross Weight" dataType="string" />
                                    <Column allowFiltering={true} dataField="certificateNo" caption="IGI Number" dataType="string" />
                                    <Column allowFiltering={true} dataField="huid" caption="HUID" dataType="string" />
                                    <Column allowFiltering={false} dataField="mrpPrice" format="#,##0.00" caption="Selling Price" dataType="string" />
                                    <Column allowFiltering={false} dataField="dpPrice" format="#,##0.00" caption="Depository Participant Price" dataType="string" />
                                    <Column allowFiltering={false} dataField="diaWt" format="#,##0.000" caption="Diamond Weight" dataType="number" />
                                    <Column allowFiltering={false} dataField="diaQty" caption="Diamond Quality" dataType="string" />
                                    <Column allowFiltering={false} dataField="metalColor" caption="Diamond Color" dataType="string" />
                                    <Column allowFiltering={false} dataField="diaMrp" format="#,##0.00" caption="Diamond MRP" dataType="number" />
                                    <Column allowFiltering={false} dataField="colorStonePrice" format="#,##0.00" caption="Color Stone MRP" dataType="number" />
                                    <Column allowFiltering={false} dataField="metalMrp" format="#,##0.00" caption="Meterial MRP" dataType="number" />
                                    <Column allowFiltering={false} dataField="labMrp" format="#,##0.00" caption="Lab MRP" dataType="number" />
                                    <Column allowFiltering={false} dataField="oldMrp" format="#,##0.00" caption="Old MRP" dataType="number" />
                                    <Column allowFiltering={false}
                                        dataField="isSRP"
                                        caption="Selling type" dataType="boolean"

                                        cellRender={({ data }) => (
                                            <span>{data?.isSRP ? "SRP" : "MRP"}</span>
                                        )}
                                    />
                                </DataGrid>}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </React.Fragment >
    );
}
export default DiamondProductInventory;